import React, { useState, useCallback, useMemo } from 'react';
import { Icon, ButtonMenu, TextField, Skeleton } from '@ann/web-components';
import { useHomeChat } from '../../../../context';
import {
  TopbarContainer,
  ActionsWrapper,
  ActionButton,
  CloseButton,
  ButtonMenuWrapper
} from './ChatTopbar.styled';

const ChatTopbar = ({ onClose, onViewHistory, onOpenInHome }) => {
  const {
    selectedAgent,
    selectedConversationId,
    openConversationSearch,
    agents,
    selectedAgentId,
    selectAgent,
    selectConversation,
    clearConversationSelection,
    cleanThread,
    activeScope,
    defaultAgentForNewChat,
    isLoadingAgentDetails,
  } = useHomeChat();

  const [agentSearch, setAgentSearch] = useState('');

  const agentSelectorLabel = isLoadingAgentDetails ? (
    <Skeleton height="20px" width="120px" borderRadius="6px" />
  ) : (
    selectedAgent?.name || 'Chat'
  );
  const isInConversation = !!selectedConversationId;

  // TODO(COPILOT): Re-enable when backend supports synthetic Copilot agent UUID.
  // Sending messages with copilot-{scope} as assistant_uuid currently fails.
  const agentsWithCopilot = useMemo(() => {
    return agents ?? [];
    // if (!activeScope || !defaultAgentForNewChat?.isCopilot) return agents ?? [];
    // const copilot = defaultAgentForNewChat;
    // const realAgents = agents ?? [];
    // const exists = realAgents.some((a) => (a.uuid || a.id) === copilot.id);
    // if (exists) return realAgents;
    // return [copilot, ...realAgents];
  }, [agents /* activeScope, defaultAgentForNewChat */]);

  const filteredAgents = useMemo(() => {
    if (!agentsWithCopilot?.length) return [];
    if (!agentSearch.trim()) return agentsWithCopilot;
    const term = agentSearch.toLowerCase();
    return agentsWithCopilot.filter((a) => (a.name || '').toLowerCase().includes(term));
  }, [agentsWithCopilot, agentSearch]);

  const handleAgentSearchChange = useCallback((val) => {
    const value = typeof val === 'string' ? val : val?.target?.value ?? '';
    setAgentSearch(value);
  }, []);

  const handleAgentChange = useCallback((value) => {
    const agent = agentsWithCopilot?.find((a) => (a.uuid || a.id) === value);
    if (!agent) return;
    selectAgent(value, agent);
    selectConversation(null);
    setAgentSearch('');
  }, [agentsWithCopilot, selectAgent, selectConversation]);

  const handleNewChat = useCallback(() => {
    clearConversationSelection();
    cleanThread();
  }, [clearConversationSelection, cleanThread]);

  return (
    <TopbarContainer>
      <ButtonMenu
        alignMenu="left"
        disableEffects
        iconPosition="right"
        label={agentSelectorLabel}
        menuPosition="bottom"
        onChange={handleAgentChange}
        size="medium"
        type="tertiary"
        width="auto"
      >
        <ButtonMenu.Menu>
          <TextField
            iconLeft="search"
            label=""
            onChange={handleAgentSearchChange}
            size="small"
            placeholder="Search agents"
            value={agentSearch}
          />
          {filteredAgents.map((agent) => {
            const agentId = agent.uuid || agent.id;
            return (
              <ButtonMenu.Item
                key={agentId}
                label={agent.name || 'Unnamed Agent'}
                value={agentId}
                icon={selectedAgentId === agentId ? 'check' : undefined}
              />
            );
          })}
          {filteredAgents.length === 0 && (
            <ButtonMenu.Item label="No agents found" value="" disabled />
          )}
        </ButtonMenu.Menu>
      </ButtonMenu>

      <ActionsWrapper>
        {isInConversation && (
          <>
            <ActionButton type="button" aria-label="New chat" onClick={handleNewChat}>
              <Icon name="edit_square" size="custom" width="16px" height="16px" color="neutral" />
            </ActionButton>
            <ActionButton type="button" aria-label="Search" onClick={openConversationSearch}>
              <Icon name="search" size="custom" width="16px" height="16px" color="neutral" />
            </ActionButton>
          </>
        )}
        <ButtonMenuWrapper aria-label="More options">
          <ButtonMenu
            customIcon="dotsMenu"
            iconPosition="right"
            alignMenu="right"
            label=""
            menuPosition="bottom"
            onChange={(value) => {
              if (value === 'view_past_conversations') {
                onViewHistory?.();
              } else if (value === 'open_in_home') {
                onOpenInHome?.();
              }
            }}
            size="small"
            type="tertiary"
            width="auto"
            className="chat-topbar-menu"
          >
            <ButtonMenu.Menu icon={true}>
              <ButtonMenu.Item
                icon="update"
                label="View past conversations"
                value="view_past_conversations"
              />
              {/* <ButtonMenu.Item
                icon="edit"
                label="Edit Agent"
                value="edit_agent"
              /> */}
              {onOpenInHome && isInConversation && (
                <ButtonMenu.Item
                  icon="arrowOutward"
                  label="Open in home"
                  value="open_in_home"
                />
              )}
              {/* <ButtonMenu.Item
                icon="delete2"
                label="Delete chat"
                value="delete_chat"
              /> */}
            </ButtonMenu.Menu>
          </ButtonMenu>
        </ButtonMenuWrapper>
        {onClose && (
          <CloseButton onClick={onClose} type="button" aria-label="Close chat">
            <Icon name="close" size="custom" width="16px" height="16px" color="neutral" />
          </CloseButton>
        )}
      </ActionsWrapper>
    </TopbarContainer>
  );
};

export default ChatTopbar;
